import Grid from '../../components/UI/Grid/Grid';
import useAuditTrails from '../../hooks/useAuditTrails';
import AuditGridFilter from './AuditGridFilter';

const AuditGrid = () => {
    const hook = useAuditTrails(),
        { gridData, gridHeaders, gridMeta, onGridPage } = hook;

    return (
        <>
            <section className="container-fluid card p-4 mb-5">
                <div className="row">
                    <div className="col-12">
                        <AuditGridFilter hook={hook} />
                    </div>
                </div>
            </section>
            <section className="container-fluid card p-4 mb-5">
                <div className="row">
                    <div className="col-12">
                        <Grid
                            paginator={true}
                            lazy={true}
                            total={gridMeta.total}
                            rows={gridMeta.limit}
                            first={gridMeta.offset}
                            onPage={onGridPage}
                            columns={gridHeaders}
                            data={gridData}
                        />
                    </div>
                </div>
            </section>
        </>
    );
};

export default AuditGrid;
